var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/emoji_picker.tsx";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';
import classNames from 'classnames';
import { List as ImmutableList } from 'immutable';
import React from 'react';
import ReactDOM from 'react-dom';
import { defineMessages, useIntl } from 'react-intl';
import { createSelector } from 'reselect';
import { IconButton } from 'soapbox/components/ui';
import { useTheme } from 'soapbox/hooks';
import { isMobile, isUserTouching } from 'soapbox/is_mobile';
const messages = defineMessages({
  emoji: {
    "id": "emoji_button.label",
    "defaultMessage": "Insert emoji"
  },
  emoji_search: {
    "id": "emoji_button.search",
    "defaultMessage": "Search\u2026"
  },
  emoji_not_found: {
    "id": "emoji_button.not_found",
    "defaultMessage": "No emoji's found."
  },
  custom: {
    "id": "emoji_button.custom",
    "defaultMessage": "Custom"
  },
  recent: {
    "id": "emoji_button.recent",
    "defaultMessage": "Frequently used"
  },
  search_results: {
    "id": "emoji_button.search_results",
    "defaultMessage": "Search results"
  },
  people: {
    "id": "emoji_button.people",
    "defaultMessage": "People"
  },
  nature: {
    "id": "emoji_button.nature",
    "defaultMessage": "Nature"
  },
  food: {
    "id": "emoji_button.food",
    "defaultMessage": "Food & Drink"
  },
  activity: {
    "id": "emoji_button.activity",
    "defaultMessage": "Activity"
  },
  travel: {
    "id": "emoji_button.travel",
    "defaultMessage": "Travel & Places"
  },
  objects: {
    "id": "emoji_button.objects",
    "defaultMessage": "Objects"
  },
  symbols: {
    "id": "emoji_button.symbols",
    "defaultMessage": "Symbols"
  },
  flags: {
    "id": "emoji_button.flags",
    "defaultMessage": "Flags"
  },
  skins: {
    "id": "emoji_button.skins",
    "defaultMessage": "Skins"
  }
});
export const getCustomEmojis = createSelector([state => state.get('custom_emojis')], emojis => emojis.filter(e => e.get('visible_in_picker')).sort((a, b) => {
  const aShort = a.get('shortcode').toLowerCase();
  const bShort = b.get('shortcode').toLowerCase();
  if (aShort < bShort) {
    return -1;
  } else if (aShort > bShort) {
    return 1;
  } else {
    return 0;
  }
}));
const Wrapper = ({
  show,
  onClose,
  children
}) => {
  if (!show) return null;
  return /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/React.createElement("div", {
    className: "emoji-picker fixed top-0 left-0 w-screen h-screen bg-gray-800 z-[100]",
    onKeyPress: e => e.stopPropagation(),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 56,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-slate-800  flex flex-col overflow-hidden sm:rounded-lg absolute top-1/2 left-1/2 -translate-x-[50%] -translate-y-[50%] ",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: "ml-auto text-gray-500",
    src: require('@tabler/icons/x.svg'),
    onClick: onClose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 11
    }
  })), children)), document.body);
};
export const EmojiPickerModal = ({
  custom_emojis = ImmutableList(),
  active,
  onClose,
  onPickEmoji
}) => {
  const intl = useIntl();
  const theme = useTheme();
  const handleClose = React.useCallback((e = null) => {
    if (e) {
      e.stopPropagation();
    }
    onClose();
  }, []);
  const buildCustomEmojis = React.useCallback(custom_emojis => {
    const emojis = custom_emojis.map(emoji => ({
      id: emoji.get('shortcode'),
      name: emoji.get('shortcode'),
      keywords: [emoji.get('shortcode')],
      skins: [{
        src: emoji.get('static_url')
      }]
    })).toJS();
    return [{
      id: 'custom',
      name: intl.formatMessage(messages.custom),
      emojis
    }];
  }, []);
  const handlePick = React.useCallback(emoji => {
    onPickEmoji(_objectSpread(_objectSpread({}, emoji), {}, {
      native: emoji.native || emoji.shortcodes
    }));
    handleClose();
  }, [handleClose, onPickEmoji]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    show: active,
    onClose: handleClose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 111,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Picker, {
    autoFocus: !isUserTouching(),
    theme: theme,
    dynamicWidth: isMobile(window.innerWidth),
    categories: ['frequent', 'custom', 'people', 'nature', 'foods', 'activity', 'places', 'objects', 'symbols', 'flags'],
    previewPosition: "none",
    custom: buildCustomEmojis(custom_emojis),
    data: data,
    onEmojiSelect: handlePick,
    i18n: {
      search: intl.formatMessage(messages.emoji_search),
      notfound: intl.formatMessage(messages.emoji_not_found),
      skins: intl.formatMessage(messages.skins),
      categories: {
        search: intl.formatMessage(messages.search_results),
        recent: intl.formatMessage(messages.recent),
        people: intl.formatMessage(messages.people),
        nature: intl.formatMessage(messages.nature),
        foods: intl.formatMessage(messages.food),
        activity: intl.formatMessage(messages.activity),
        places: intl.formatMessage(messages.travel),
        objects: intl.formatMessage(messages.objects),
        symbols: intl.formatMessage(messages.symbols),
        flags: intl.formatMessage(messages.flags),
        custom: intl.formatMessage(messages.custom)
      }
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 112,
      columnNumber: 7
    }
  }));
};
const EmojiPickerUI = ({
  custom_emojis = ImmutableList(),
  button,
  onPickEmoji
}) => {
  const root = React.useRef(null);
  const [active, setActive] = React.useState(false);
  const handleClose = React.useCallback(() => {
    setActive(false);
  }, []);
  const handleToggle = React.useCallback(e => {
    e.stopPropagation();
    if (e.key === 'Escape') {
      setActive(false);
      return;
    }
    if (!e.key || e.key === 'Enter') {
      setActive(!active);
    }
  }, [active]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative",
    ref: root,
    onKeyDown: handleToggle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 178,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: handleToggle,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 179,
      columnNumber: 9
    }
  }, button || /*#__PURE__*/React.createElement(IconButton, {
    className: classNames({
      'text-gray-400 hover:text-gray-600': true
    })
    // @ts-expect-error alt
    ,
    alt: "\uD83D\uDE00",
    src: require('@tabler/icons/mood-happy.svg'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 181,
      columnNumber: 23
    }
  })), /*#__PURE__*/React.createElement(EmojiPickerModal, {
    active: active,
    onClose: handleClose,
    onPickEmoji: onPickEmoji,
    custom_emojis: custom_emojis,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 191,
      columnNumber: 9
    }
  })));
};
export default EmojiPickerUI;